"use client"

import { convertToLocale } from "@/lib/helpers/money"
import { useTranslate } from "@tolgee/react"

export const CartSummary = ({
  item_total,
  shipping_total,
  total,
  currency_code,
  tax,
}: {
  item_total: number
  shipping_total: number
  total: number
  currency_code: string
  tax: number
}) => {
  const { t } = useTranslate()
  return (
    <div>
      <div className="space-y-3 text-[14px] text-[#8C8C8C] mb-3">
        <div className="flex justify-between">
          <span>{t("cart_summary.items")}</span>
          <span className="text-[#1A1A1A]">
            {convertToLocale({
              amount: item_total,
              currency_code,
            })}
          </span>
        </div>
        <div className="flex justify-between">
          <span>{t("cart_summary.tax")}</span>
          <span className="text-[#1A1A1A]">
            {convertToLocale({
              amount: tax,
              currency_code,
            })}
          </span>
        </div>
        <div className="flex justify-between">
          <span>{t("cart_summary.delivery")}</span>
          <span className="text-[#1A1A1A]">
            {convertToLocale({
              amount: shipping_total,
              currency_code,
            })}
          </span>
        </div>
      </div>
      <div className="flex justify-between border-t border-neutral-200 pt-2 mt-2">
        <span className="text-[14px] text-[#8C8C8C]">{t("cart_summary.total")}</span>
        <span className="text-base text-[#101828]" style={{ fontWeight: 600 }}>
          {convertToLocale({
            amount: total,
            currency_code,
          })}
        </span>
      </div>
    </div>
  )
}
